





























































































































import { Vue, Component } from 'vue-property-decorator';
import qs from 'qs';
import { save, ifSave, getRule } from '../api';
import PickerInput from '../components/PickerInputold.vue';
import SyEditor from '@/components/SyEditor.vue';
import { isWeiXin } from '@/common/ts/common';
import { Field, Cell, CellGroup, Toast, Calendar } from 'vant';
import Uploader from '@/components/next/NewUploader.vue';

Vue.use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Calendar);
@Component({
  components: {
    PickerInput,
    SyEditor,
    Uploader,
  },
})
export default class Save extends Vue {
  rule: string = '';
  name: string = '';
  phone: string = '';
  title: string = '';
  age: string = '';
  sex: string = '';
  native: string = '';
  commpany: string = '';
  unionid: string | null = '';
  // save: boolean = false;
  show: boolean = false;
  downLoadUrl: string =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  options: any = ['男', '女'];
  cover: any = [];

  async mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
    const data = {
      unionid: this.unionid,
      token: window.gettoken(),
      appkey: window.appkey,
      wdid: window.udid,
    };
    const rule: any = await getRule();
    this.rule = rule.data;
    // const res: any = await ifSave(data);
    // if (res.code === 200) {
    //   this.save = true;
    // }
  }
  selectData1(e: any) {
    this.sex = e + '';
  }
  async getCover() {
    this.cover = (await (this.$refs
      .uploaderImg as Uploader).uploadToOss()) as string[];
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async submit() {
    if (!isWeiXin() && !window.udid) {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App进行投票',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          // console.log(action);
          window.location.href = this.downLoadUrl;
        })
        .catch((action) => {
          // console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
        });
      return;
    } else if (!this.title) {
      Toast('请填写征文标题！');
      return false;
    } else if (!this.name) {
      Toast('请填写姓名！');
      return false;
    } else if (!this.sex) {
      Toast('请填写性别！');
      return false;
    } else if (!this.age) {
      Toast('请填写年龄！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!(this.$refs.editor as SyEditor).content) {
      Toast('请填写正文');
      return false;
    } else {
      const namelsit = this.name.split('、');
      if (namelsit.length > 3) {
        Toast('请输入最多三个姓名，以、隔开');
        return false;
      }
      if (window.tinymce.activeEditor.plugins.wordcount.getCount() > 6000) {
        Toast('正文长度不能超过6000字');
        return false;
      }
      const data = {
        name: this.name,
        phone: this.phone,
        title: this.title,
        age: this.age,
        sex: this.sex,
        native: this.native,
        commpany: this.commpany,
        introduction: (this.$refs.editor as SyEditor).content,
        unionid: this.unionid,
        token: window.gettoken(),
        appkey: window.appkey,
        udid: window.udid,
        cover: this.cover.join('|'),
      };
      const res: any = await save(data);
      if (res.code === 200) {
        Toast(`${res.msg}`);
        setTimeout(() => {
          this.$router.go(0);
        }, 2000);
      } else {
        Toast(`${res.msg}`);
      }
    }
  }
  // checkContent(data: any) {
  //   if (!data) {
  //     return 0;
  //   }
  //   const isHtml = /<\/?.+?\/?>/g;
  //   const isImg = /<img.*?(?:>|\/>)/gi;
  //   const isVideo = /<video.*?(?:>|\/>)/gi;
  //   const getData = String(data); // data为富文本转换的html
  //   const getDataLenght = getData
  //     ? getData
  //         .replace(isImg, '1')
  //         .replace(isVideo, '1')
  //         .replace(isHtml, '').length
  //     : 0;
  //   return getDataLenght;
  // }
}
